import { configureStore } from '@reduxjs/toolkit';
import { reducer as reduxFormReducer } from "redux-form";
import { serversReducer } from './servers/serversReducer';
import { schemasReducer } from "./schemas/schemasReducer";
import { esmeReducer } from './esme/esmeReducer';
import { smscReducer } from './smsc/smscReducer';
import { deploymentsReducer } from './deployments/deploymentsReducer';
import { commitsReducer } from './commits/commitsReducer';
import { bearerboxReducer } from './bearerbox/bearerboxReducer';
import { smppboxReducer } from './smppbox/smppboxReducer';

const store = configureStore({
  devTools: process.env.NODE_ENV === 'development',
  reducer: {
    servers: serversReducer,
    smppbox: smppboxReducer,
    bearerbox: bearerboxReducer,
    schemas: schemasReducer,
    commits: commitsReducer,
    esme: esmeReducer,
    smsc: smscReducer,
    deployments: deploymentsReducer,
    form: reduxFormReducer,
  },
});

export default store;

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
